module.exports = __webpack_public_path__ + "img/ico_menual10_off.b96c57ca.svg";